/**
 * Order Source → Manual Classification mapping for Amplitude Consolidated_Traffic_Source_Category.
 * Source: Marketing Attribution Dashboard (Order Source → Manual Classification).
 */
export const ORDER_SOURCE_TO_CATEGORY: Record<string, string> = {
    'Google_Ads': 'SEM',
    'App': 'APP',
    'Direct': 'DIRECT',
    'Marketing_Email': 'EMAIL',
    'Way_Angular-Direct': 'DIRECT',
    'Way_Angular-Google_Ads': 'SEM',
    'Way_Angular-impact': 'Affiliates',
    'google': 'Others',
    'Bing_Ads': 'SEM',
    'google_SEO': 'SEO',
    'google_maps': 'Google Places',
    'Abandonedcartpromo': 'EMAIL',
    'Way_Static-Google_Ads': 'SEM',
    'Way_Angular-Marketing_Email': 'EMAIL',
    'Way_Angular-google_SEO': 'SEO',
    'Other-https://capitaloneshopping.com/': 'SEO',
    'Way_Angular-Bing_Ads': 'SEM',
    'Way_Static-google_SEO': 'SEO',
    'Way_Angular-Abandonedcartpromo': 'EMAIL',
    'Way_Static-Bing_Ads': 'SEM',
    'Way_Angular-ifly_micro_atl': 'Affiliates',
    'Other-https://www.rakuten.com/': 'Referral',
    'Way_Static-Marketing_Email': 'EMAIL',
    'bing_SEO': 'SEO',
    'bing': 'Others',
    'Way_Angular-Other-android-app://com.google.android': 'DIRECT',
    'Other-https://simplycodes.com/store/globalairportp': 'Referral',
    'Way_Angular-google': 'DIRECT',
    'Other-https://simplycodes.com/': 'Referral',
    'Way_Angular-ifly': 'Affiliates',
    'social_X': 'Organic',
    'Way_Angular-bing_SEO': 'SEO',
    'duckduckgo_SEO': 'SEO',
    'Way_Static-duckduckgo_SEO': 'SEO',
    'yahoo_SEO': 'SEO',
    'Way_Angular-Email': 'EMAIL',
    'Other-android-app://com.google.android.gm/': 'DIRECT',
    'Way_Angular-ifly_micro_pdx': 'Affiliates',
    'Other-https://couponcause.com/': 'Referral',
    'Way_Static-google': 'DIRECT',
    'Way_Angular-ifly_micro_dca': 'Affiliates',
    'Other-https://globalparking.knoji.com/promo-codes/': 'EMAIL',
    'Way_Static-bing_SEO': 'SEO',
    'chatgpt.com': 'Chatgpt',
    'Way_Static-yahoo_SEO': 'SEO',
    'Way_Static-impact': 'Affiliates',
    'Way_Angular-duckduckgo_SEO': 'SEO',
    'Other-android-app://com.google.android.googlequick': 'DIRECT',
    'Other-https://airportsparking.com/': 'DIRECT',
    'Other-https://cheapestairportparking.com/': 'DIRECT',
    'Other-https://www.selectaware.com/': 'Referral',
    'Way_Angular-Other-https://capitaloneshopping.com/': 'Affiliates',
    'Way_Angular-yahoo_SEO': 'SEO',
    'Way_Static-Direct': 'DIRECT',
    'Other-https://search.brave.com/': 'Referral',
    'Way_Angular-Other-https://ntp.msn.com/': 'Direct',
    'Way_Angular-Other-https://simplycodes.com/store/cheapestairpor': 'Referral',
    'Way_Angular-chatgpt.com': 'Chatgpt',
    'Way_Static-chatgpt.com': 'Chatgpt',
    'social_Facebook': 'Organic',
    'Way_Angular-Other-https://aspca.okta.com/': 'Referral',
    'Other-https://dealspotr.com/promo-codes/airportspa': 'Referral',
    'Way_Angular-Pre_Cart_Email': 'EMAIL',
    'Way_Angular-Other-https://www.rakuten.com/': 'Referral',
    'Way_Angular-social_X': 'Organic',
    'Other-https://globalparking.knoji.com/': 'Referral',
    'Way_Angular-cap_post_order_checkout_email': 'EMAIL',
    'Way_Angular-Other-https://waypanel.way.com/': 'Internal',
    'Other-https://www.goodsearch.com/': 'Referral',
    'Way_Angular-Other-https://fatcoupon.com/': 'Referral',
    'Way_Angular-Other-https://shop.id.me/': 'Referral',
    'Other-https://airportsparking.brokescholar.com/': 'Affiliates',
    'Way_Angular-ifly_micro_rdu': 'Affiliates',
    'Other-https://dealspotr.com/': 'Referral',
    'checkmate': 'Others',
    'Way_Angular-SignUp': 'DIRECT',
    'Other-https://m.selectaware.com/': 'Referral',
    'Other-https://refermate.com/': 'Referral',
    'Other-https://www.topcashback.com/': 'Referral',
    'email_cta': 'EMAIL',
    'Pre_Cart_Email': 'EMAIL',
    'Way_Angular-ifly_micro_sjc': 'Affiliates',
    'Way_Angular-Other-https://waysupport.page.link/': 'DIRECT',
    'Way_Angular-Other-android-app://com.reddit.frontpa': 'Referral',
    'social_Instagram': 'Organic',
    'Way_Angular-ifly_micro_alb': 'Affiliates',
    'perplexity': 'Chatgpt',
    'klarna': 'Others',
    'Way_Angular-Other-https://couponfollow.com/': 'Referral',
    'Other-https://dealspotr.com/promo-codes/cruisepark': 'Referral',
    'Other-https://globalairportparking.valuecom.com/': 'Referral',
    'Way_Angular-Klaviyo': 'EMAIL',
    'Way_Angular-Other-https://search.brave.com/': 'DIRECT',
    'Way_Angular-bing': 'DIRECT',
    'Way_Angular-Airport_Order_Confirmation': 'DIRECT',
    'Way_Static-social_X': 'Organic',
    'Way_Angular-Other-https://waycom.sjv.io/': 'Referral',
    'Other-https://globalairportparking.worthepenny.com': 'Affiliates',
    'Other-https://syndicatedsearch.goog/': 'Referral',
    'impact': 'Affiliates',
    'Way_Static-Other-https://search.brave.com/': 'DIRECT',
    'Way_Angular-ifly_micro_bur': 'Affiliates',
    'Way_Angular-Facebook_Ads': 'Meta Ads',
    'Way_Angular-Other-https://outlook.live.com/': 'Referral',
    'Other-https://safe.menlosecurity.com/': 'Referral',
    'Way_Angular-Other-https://myemail.optimum.net/': 'EMAIL',
    'Other-https://www.realcodes.org/': 'Referral',
    'Other-https://www.ecosia.org/': 'Referral',
    'Way_Angular-ifly_micro_sat': 'Affiliates',
    'Other-https://www.joinhoney.com/': 'Referral',
    'Other-https://www.dontpayfull.com/': 'Referral',
    'Way_Angular-CAP Order Confirmation': 'DIRECT',
    'email': 'EMAIL',
    'mailchimp_AllVertical': 'EMAIL',
    'Other-https://dealspotr.com/promo-codes/globalairp': 'Referral',
    'Way_Angular-Other-https://trkaud.net/': 'Referral',
    'Way_Angular-Other-https://www.travelmag.com/': 'Referral',
    'Way_Angular-trustpilot': 'Chatgpt',
    'Way_Angular-AirportsParking Order Confirmation': 'DIRECT',
    'Other-https://outlook.live.com/': 'Referral',
    'Other-https://chpstairprtprkng.knoji.com/': 'Referral',
    'Way_Static-bing': 'Direct',
    'Way_Angular-CruiseParking Order Confirmation': 'DIRECT',
    'Way_Angular-Google Integrations': 'Others',
    'Way_Angular-abenity': 'Referral',
    'Other-https://search.aol.com/': 'Referral',
    'Way_Angular-Other-https://www.google.ca/': 'DIRECT',
    'google%26utm_medium=cpc%26utm_campaign=LAX_Airport': 'SEM',
    'Way_Angular-Other-https://m.selectaware.com/': 'Referral',
    'Other-https://www.goodsearch.com/coupons/airportla': 'Referral',
    'Way_Angular-FindParking Order Confirmation': 'Direct',
    'Way_Static-Other-https://claude.ai/': 'Chatgpt',
    'Other-https://www.google.ca/': 'Referral',
    'Way_Angular-Other-https://tatrck.com/37AKG0hUHq': 'Referral',
    'Other-https://s.gocashback.com/': 'Referral',
    'Way_Angular-way': 'Direct',
    'Way_Angular-Other-https://app.nordpass.com/': 'Referral',
    'Way_Angular-Other-https://freespoke.com/': 'Referral',
    'Other-https://webmaila.juno.com/': 'EMAIL',
    'Other-https://airportsparking.brokescholar.com/cou': 'Referral',
    'Way_Angular-Other-https://webmailb.netzero.net/': 'EMAIL',
    'Other-https://www.startpage.com/': 'Referral',
    'Other-https://www.icloud.com/': 'Referral',
    'Way_Static-Other-https://www.ecosia.org/': 'Referral',
    'Way_Static-Other-https://www.google.ca/': 'Others',
    'google&utm_medium=cpc&utm_campaign=LAX_Airport_Par': 'SEM',
    'Way_Static-Pre_Cart_Email': 'EMAIL',
    'Way_Angular-Other-https://www.narcity.com/toronto/': 'Referral',
    'Way_Angular-Other-https://way.onelink.me/': 'Referral',
    'Way_Angular-Other-https://search.aol.com/': 'Referral',
    'Other-https://www.karmanow.com/': 'Referral',
    'Way_Angular-Other-https://login.microsoftonline.co': 'Direct',
    'Way_Angular-Other-https://www.selectaware.com/': 'Referral',
    'Way_Angular-Other-https://couponcause.com/': 'Referral',
    'Way_Static-mailchimp_HeroImage': 'EMAIL',
    'Way_Angular-Other-https://www.msn.com/': 'Direct',
    'Other-https://www.selectaware.com/stores/Airport-L': 'Referral',
    'google&utm_medium=cpc&utm_campaign=EWR_Airport_Par': 'SEM',
    'Other-https://www.freeshipping.com/': 'Referral',
    'Other-https://statics.teams.cdn.office.net/': 'Referral',
    'Way_Static-Other-https://waycom.sjv.io/': 'Referral',
    'Way_Static-Other-https://stacker.com/': 'Referral',
    'Other-https://findparking.com/': 'DIRECT',
    'null': 'Others',
    'Way_Angular-Other-https://poczta.wp.pl/': 'Referral',
    'Other-https://www.worthepenny.com/': 'Referral',
    'mailchimp_AirportPark': 'EMAIL',
    'Other-https://webmail1.earthlink.net/': 'EMAIL',
    'Other-https://webmail.centurylink.net/': 'Referral',
    'Other-https://www.retailmenot.com/view/airportlax.': 'Referral',
    'Other-https://lastpass.com/': 'Referral',
    'CAP': 'Others',
    'Way_Angular-ifly_micro_sfo': 'Affiliates',
    'trustpilot': 'Referral',
    'Way_Angular-Other-https://www.cheapestairportparki': 'Referral',
    'Way_Angular-social_Facebook': 'Organic',
    'Other-https://dealspotr.com/promo-codes/cheapestai': 'Referral',
    'Airport_Order_Confirmation': 'Direct',
    'Way_Angular-Airport_2/4_Hr_Reminder': 'Direct',
    'Other-https://chpstairprtprkng.knoji.com/promo-cod': 'Referral',
    'Way_Angular-social_Youtube': 'Organic',
    'Other-https://claude.ai/': 'Chatgpt',
    'Other-https://www.couponcabin.com/': 'Referral',
    'Other-https://lnk.mail.globalairportparking.com/': 'EMAIL',
    'Other-https://search.yahoo.co.jp/': 'Referral',
    'Way_Static-Other-https://www.perplexity.ai/': 'Chatgpt',
    'Way_Angular-Other-https://statics.teams.cdn.office': 'Referral',
    'Way_Angular-mailchimp_Logo': 'EMAIL',
    'Other-https://customsearch.netshoppers.co/': 'Referral',
    'Way_Angular-ifly_micro_mci': 'Affiliates',
    'Other-https://flo.uri.sh/': 'Referral',
    'Other-https://www.shop.com/': 'Referral',
    'Way_Angular-Other-https://www.selectaware.com/stor': 'Referral',
    'Way_Angular-mailchimp_AllPark': 'EMAIL',
    'Other-https://www-airportsparking-com.cdn.ampproje': 'Referral',
    'Other-https://cheapest-airport-parking.pxf.io/': 'Referral',
    'Way_Angular-Other-https://www.ecosia.org/': 'Referral',
    'Way_Static-Other-https://capitaloneshopping.com/': 'Affiliates',
    'Other-https://s.gocashback.com/track/211efAJC7uSiF': 'Referral',
    'Way_Static-Other-android-app://com.reddit.frontpag': 'Referral',
    'Way_Angular-Other-https://dashboard.stripe.com/': 'DIRECT',
    'Way_Angular-Other-https://connect.xfinity.com/': 'Referral',
    'Way_Angular-chrome': 'DIRECT',
    'Other-https://tatrck.com/2x3TDOaIO0': 'Referral',
    'Way_Angular-Other-https://www.findparking.com/': 'Direct',
    'Way_Angular-Order_Confirmation_Email': 'EMAIL',
    'Other-https://upgradedreviews.com/': 'Referral',
    'Way_Angular-bwise': 'Referral',
    'Other-https://airportlax.com/': 'Direct',
    'Way_Angular-Other-https://go.onelink.me/': 'Referral',
    'social_Youtube': 'Organic',
    'Way_Static-Other-https://www.travelmag.com/': 'Referral',
    'Other-https://www.savings.com/': 'Referral',
    'Way_Angular-Netcore': 'EMAIL',
    'Way_Angular-Other-https://ww44.affinity.net/': 'Referral',
    'Way_Angular-mailchimp_HeroImage': 'EMAIL',
    'Way_Angular-mailchimpcrosssell_Parking': 'EMAIL',
    'Other-https://globalairportparking.com/': 'Direct',
    'Other-https://10s.best/': 'Referral',
    'Other-https://refermate.com/stores/cheapest-airpor': 'Referral',
    'Other-https://www.perplexity.ai/': 'Chatgpt',
    'Way_Angular-social_Instagram': 'Organic',
    'Way_Angular-Truecut': 'Referral',
    'Other-https://dealspotr.com/promo-codes/airportlax': 'Referral',
    'Way_Angular-Other-https://www.nicecodes.org/coupon': 'Referral',
    'Way_Angular-Other-https://way.com/': 'DIRECT',
    'Other-https://simplycodes.com/store/airportlax.com': 'Referral',
    'Way_Angular-google&utm_medium=cpc&utm_campaign=PMa': 'SEM',
    'Other-https://deref-mail.com/': 'EMAIL',
    'google&utm_medium=cpc&utm_campaign=PDX_Airport-Par': 'SEM',
    'Other-https://www.aol.com/favorites/': 'Referral',
    'Way_Static-Other-https://search.pch.com/search?q=l': 'Referral',
    'Way_Static-Other-https://search.aol.com/': 'Referral',
    'Way_Angular-Other-https://www.topcashback.com/': 'Referral',
    'Other-https://cruiseparking.com/': 'Direct',
    'google&utm_medium=cpc&utm_campaign=SAN_Airport_Par': 'SEM',
    'Other-https://simplycodes.com/category/places/tran': 'Referral',
    'Other-https://app.partnermatic.com/track/108baigOm': 'Referral',
    'Other-https://www.yelp.com/': 'Referral',
    'Way_Angular-Other-https://search.yahoo.co.jp/': 'Direct',
    'Way_Angular-Other-https://www.bravodeal.com/': 'Referral',
    'Other-https://webmailb.netzero.net/': 'Referral',
    'Thank you page': 'DIRECT',
    'Other-https://webmailb.juno.com/': 'Referral',
    'Other-http://webmailb.netzero.net/': 'Referral',
    'bwise': 'Others',
    'Other-https://cruiseparking.knoji.com/promo-codes/': 'Referral',
    'Other-https://search.avgbrowser.com/serp?q=airport': 'Referral',
    'gc': 'Others',
    'Way_Angular-Other-https://deref-mail.com/': 'Referral',
    'Way_Angular-Order_Edit': 'Direct',
    'Way_Angular-Other-https://www.coupons.com/': 'Referral',
    'Way_Angular-AirportLax Order Confirmation': 'Direct',
    'Other-http://elink.mail.globalairportparkingdeals.': 'EMAIL',
    'Other-https://athenanet.athenahealth.com/': 'Referral',
    'google&utm_medium=cpc&utm_campaign=DCA_Airport_Par': 'SEM',
    'mailchimp&utm_medium=email&utm_campaign=11.24&utm_': 'EMAIL',
    'Other-https://www.nicecodes.org/': 'Referral',
    'Way_Angular-cj': 'Referral',
    'Other-https://www.worthepenny.com/search?query=GLO': 'Referral',
    'Way_Angular-shareasale': 'Referral',
    'google&utm_medium=cpc&utm_campaign=USA_Airport_Par': 'SEM',
    'Way_Static-mailchimp_CityPark': 'EMAIL',
    'Way_Angular-Other-https://webmail1.earthlink.net/': 'Referral',
    'Other-https://offers.thephuketnews.com/': 'Referral',
    'Other-https://mail3.spectrum.net/': 'Referral',
    'Other-https://capitaloneshopping.com': 'Affiliates',
    'Way_Angular-Mailchimp': 'EMAIL',
    'Way_Angular-perplexity': 'Chatgpt',
    'Way_Angular-Other-https://webmaila.juno.com/': 'Referral',
    'Way_Angular-Other-https://yopmail.com/': 'Referral',
    'Way_Angular-Other-https://staging.way.com/rm-servi': 'Internal',
    'Way_Angular-Other-https://qaplus.way.com/': 'Internal',
    'Way_Angular-Other-https://desk.zoho.com/': 'Referral',
    'Netcore': 'EMAIL',
    'Other-https://www.promocodes.com/': 'Affiliates',
    'Way_Static-Other-https://www.rakuten.com/': 'Affiliates',
    'Other-https://capitaloneshopping.com/s/findparking': 'Affiliates',
    'google&utm_medium=cpc&utm_campaign=SAN_Airport-Par': 'SEM',
    'Other-https://tatrck.com/euu8i3Ft3V': 'Referral',
    'Other-https://www.cruisehive.com/': 'Affiliates',
    'google&utm_medium=cpc&utm_campaign=MCO_Airport_Par': 'SEM',
    'coupon': 'Referral',
    'google&utm_medium=cpc&utm_campaign=IAH_Airport_Par': 'SEM',
    'Other-https://app.partnermatic.com/track/eaeb_aixe': 'Affiliates',
    'Way_Angular-Other-https://www.bravodeal.com/coupon': 'Affiliates',
    'Way_Static-Other-android-app://com.google.android.': 'Direct',
    'Other-https://verifiedpromocode.com/index.php/coup': 'Affiliates',
    'google&utm_medium=cpc&utm_campaign=DAL_Airport_Par': 'SEM',
    'Other-https://capitaloneshopping.com/s/cheapestair': 'Affiliates',
    'Other-https://app.partnermatic.com/track/3394cXqs6': 'Affiliates',
    'Other-https://tatrck.com/N9tCwcZebR': 'Affiliates',
    'google&utm_medium=cpc&utm_campaign=PHL_Airport-Par': 'SEM',
    'Way_Angular-Other-https://www.koreanalga.com/': 'Affiliates',
    'Way_Angular-Other-https://www.airportsparking.com/': 'Organic',
    'Way_Angular-mailchimp_Parking': 'email',
    'Other-https://search.centurylink.net/serp?q=global': 'Affiliates',
    'Other-https://www.realcodes.org/globalairportparki': 'Affiliates',
    'Way_Angular-Other-https://googleads.g.doubleclick.': 'SEM',
    'Other-https://hq.portal.tco.census.gov:6082/': 'Others',
    'Way_Angular-Other-https://www.joinhoney.com/': 'Affiliates',
    'Other-https://www.rovemiles.com/': 'Affiliates',
    '': 'Others',
    'Other-https://app.partnermatic.com/': 'Affiliates',
    'Way_Angular-Other-https://adminpanel.way.com/': 'Internal',
    'Other-https://ntp.msn.com/': 'Referral',
    'Way_Angular-Other-https://www.perplexity.ai/': 'Chatgpt',
    'Other-https://app.partnermatic.com/track/24f8gn4Lr': 'Affiliates',
    'Other-https://app.partnermatic.com/track/f34et7HUQ': 'Affiliates',
    'Way_Angular-Other-https://app.smartsuite.com/': 'Affiliates',
    'Way_Angular-Other-https://link.shoppermeet.net/': 'Affiliates',
    'Other-https://tusksearch.com/': 'Direct',
    'google&utm_medium=cpc&utm_campaign=USA_Cruise_Park': 'SEM',
    'Other-internal://local': 'Internal',
    'Other-https://share.google/': 'Referral',
    'Way_Angular-Other-https://www.tripadvisor.com/': 'Referral',
    'Other-https://yopmail.com/': 'EMAIL',
    'Other-https://afterdarkmode.net/': 'Others',
    'Way_Angular-Other-https://temp-mail.org/': 'EMAIL',
    'Way_Angular-Other-https://impactbro.com/': 'Affiliates',
    'Way_Angular-Other-https://airportparking.tips/': 'Referral',
    'Other-https://couponcause.com/stores/cheapest-airp': 'Referral',
    'Other-https://app.chatboxapp.ai/': 'Chatgpt',
    'Way_Angular-Other-https://kagi.com/': 'Direct',
  };
  